import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject, signal } from '@angular/core';
import { BaseUrlService } from './base-url.service';

/**
 * Instance de TEST ? Le même build Angular sert la prod et la préprod (seule l'URL
 * d'API change au déploiement) : c'est l'API qui le dit, via `/open/version`
 * (`environment` ≠ `production`).
 *
 * Vrai ⇒ classe `env-test` sur <html> (décale le gabarit, cf. `_env-banner.scss`)
 * et bandeau affiché par AppComponent.
 *
 * Silencieux par construction : requête en échec = pas de bandeau. En `fetch` et
 * non via ApiService, comme DemoStatusService : ni intercepteur d'authentification
 * (la page de connexion aussi doit prévenir), ni loader global.
 */
@Injectable({ providedIn: 'root' })
export class EnvironmentStatusService {
  readonly isTest = signal(false);

  private readonly baseUrl = inject(BaseUrlService);
  private readonly document = inject(DOCUMENT);
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  load(): void {
    if (!this.isBrowser) {
      return;
    }

    fetch(`${this.baseUrl.apiUrl.replace(/\/$/, '')}/open/version`, { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data: { environment?: string } | null) => {
        const isTest = !!data?.environment && data.environment !== 'production';
        this.isTest.set(isTest);
        this.document.documentElement.classList.toggle('env-test', isTest);
      })
      .catch(() => {
        /* pas d'information : pas de bandeau */
      });
  }
}
